import axios from 'axios';
import * as Config from '../../config';

const state = {};

const actions = {
    comunicacion_getAll({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'comunicacion/get-all?cuit=' + form.cuit)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    comunicacion_dispatchGetAll({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'comunicacion/dispatch-get-all?cuit=' + form.cuit + (form.now ? '&now=true' : ''))
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    comunicacion_get({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'comunicacion/get?cuit=' + form.cuit + '&idComunicacion=' + form.idComunicacion)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    comunicacion_getFile({ commit, dispatch }, path) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'comunicacion/get-file?path=' + path, {
                    responseType: 'blob' // Indicamos que esperamos una respuesta binaria
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};